<template>
  <div>
    <br />
    <p>
      Esta métrica permite comparar las estimaciones de Aquacorp frente a los valores de referencia
      del laboratorio.
    </p>
    <br />
    <p>
      <strong>MAPE <em>(Mean Absolute Percentage Error)</em>.</strong> Determina la precisión de la
      técnica de predicción frente a los datos reales mediante el cálculo de la diferencia absoluta
      promedio entre los dos valores a lo largo del tiempo, lo normaliza respecto al valor original
      para obtener la diferencia porcentual.
    </p>
    <br />
    <p>Se define de acuerdo a la siguiente fórmula:</p>
    <br />
    <div class="equation center">
      <img src="/img/iMape.png" alt="mape" class="equation-image" /><br />
    </div>
    <p>
      La <strong>y</strong> representa la estimación realizada por la tecnología de Aquacorp,
      <strong>x</strong> el valor de referencia del laboratorio y <strong>N</strong> el número de
      pares (estimaciones/valor de referencia) evaluados.
    </p>
  </div>
</template>

<style scoped>
.center {
  text-align: center;
}

.equation-image {
  max-width: 80%;
  height: 150px;
}
p {
  word-break: keep-all;
}
</style>
